module.exports = __webpack_public_path__ + "img/emptyWhite.50e41dc7.png";